import { set_dto_selected_merchant_or_product } from "../../../../classes/dto-setters/dto-setter";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { PT_PRODUCT } from "../../../../routes/stack/paths/pt-home";
import { Container } from "react-bootstrap";
import FilterItemComponent from "./item-card";
import React from "react";

export default class ViewFilterItem extends React.PureComponent {
  render() {
    return (
      <Container
        style={{
          overflowY: "hidden",
          paddingTop: 5,
        }}
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <FilterItemComponent
          data={this.props.pmData}
          ItemClick={async (rs) => {
            await this.selected_product(rs);
          }}
        />
      </Container>
    );
  }
  async selected_product(data) {
    await Api_DrawAnalyticalPath(1, data.PI);
    if (data.MT === "GR") {
      data.MT = "RS";
    }
    await set_dto_selected_merchant_or_product(data);
    this.props.navigate(
      PT_PRODUCT.replace(":frompage", "section-product")
        .replace(":navigatepage", "home-filter")
        .replace(":category", "category")
        .replace(":pid", data.PI)
        .replace(":lineid", 1)
        .replace(":adonlineid", 1)
        .replace(":isrecommended", 0)
    );
  }
}